export default __webpack_public_path__ + "static/media/right_landing_leafs.aa990fe2.png";